import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import localized from 'dayjs/plugin/localizedFormat';
import weekYear from 'dayjs/plugin/weekYear';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import advanced from 'dayjs/plugin/advancedFormat';
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localized);
dayjs.extend(weekYear);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(advanced);
Date.locale = undefined;
let is_24_hours = true;
const locales_24_hour = [
    'af-ZA', 'am-ET', 'ar-DZ', 'ar-LY', 'ar-MA', 'ar-TN', 'az-Latn-AZ', 'bg-BG', 'bn-BD', 'bs-Latn-BA',
    'ca-ES', 'cs-CZ', 'cy-GB', 'da-DK', 'de-AT', 'de-CH', 'de-DE', 'de-LI', 'de-LU', 'el-GR', 'en-150',
    'en-GB', 'en-IE', 'en-IN', 'en-NZ', 'en-ZA', 'es-AR', 'es-BO', 'es-CL', 'es-CO', 'es-CR', 'es-DO',
    'es-EC', 'es-ES', 'es-GT', 'es-HN', 'es-MX', 'es-NI', 'es-PA', 'es-PE', 'es-PY', 'es-SV', 'es-UY',
    'es-VE', 'et-EE', 'eu-ES', 'fi-FI', 'fil-PH', 'fr-BE', 'fr-CH', 'fr-FR', 'fr-LU', 'fr-MC', 'gl-ES',
    'gu-IN', 'he-IL', 'hi-IN', 'hr-BA', 'hr-HR', 'hu-HU', 'hy-AM', 'id-ID', 'is-IS', 'it-CH', 'it-IT',
    'ka-GE', 'kk-KZ', 'km-KH', 'kn-IN', 'ko-KR', 'ky-KG', 'lb-LU', 'lo-LA', 'lt-LT', 'lv-LV', 'mk-MK',
    'ml-IN', 'mn-MN', 'mr-IN', 'ms-BN', 'ms-MY', 'mt-MT', 'nb-NO', 'ne-NP', 'nl-BE', 'nl-NL', 'nn-NO',
    'or-IN', 'pa-IN', 'pl-PL', 'pt-AO', 'pt-CH', 'pt-CV', 'pt-GQ', 'pt-GW', 'pt-LU', 'pt-MO', 'pt-MZ',
    'pt-PT', 'pt-ST', 'pt-TL', 'ro-RO', 'ru-BY', 'ru-KG', 'ru-KZ', 'ru-MD', 'ru-RU', 'ru-UA', 'si-LK',
    'sk-SK', 'sl-SI', 'sq-AL', 'sr-Cyrl-BA', 'sr-Cyrl-ME', 'sr-Cyrl-RS', 'sr-Latn-BA', 'sr-Latn-ME',
    'sr-Latn-RS', 'sv-FI', 'sv-SE', 'sw-KE', 'sw-TZ', 'sw-UG', 'ta-IN', 'te-IN', 'th-TH', 'tr-CY',
    'tr-TR', 'uk-UA', 'ur-IN', 'ur-PK', 'uz-Latn-UZ', 'vi-VN', 'zh-CN', 'zh-HK', 'zh-MO', 'zh-SG'
];
function parseDate(date_str) {
    const us_re = /(\d+).(\d+).(\d+),?\s+(\d+).(\d+)(.(\d+))?/;
    date_str = date_str.replace(/[\u200E\u200F]/g, '');
    return [].slice.call(us_re.exec(date_str), 1).map(Math.floor);
}
function getTimezoneOffset(timeZone, unix) {
    const date = typeof unix === 'number'
        ? new Date(unix * 1000)
        : new Date();
    const locale = 'en-US';
    const format = {
        timeZone: 'UTC',
        hour12: false,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    };
    const local_format = new Intl.DateTimeFormat(locale, Object.assign(Object.assign({}, format), { timeZone }));
    const utc_format = new Intl.DateTimeFormat(locale, format);
    const first_date = parseDate(utc_format.format(date));
    const second_date = parseDate(local_format.format(date));
    const first_date_hours = first_date[3] === 24
        ? 0
        : first_date[3];
    const second_date_hours = second_date[3] === 24
        ? 0
        : second_date[3];
    let days = first_date[1] - second_date[1];
    const hours = first_date_hours - second_date_hours;
    const minutes = first_date[4] - second_date[4];
    if (days > 15) {
        days = -1;
    }
    if (days < -15) {
        days = 1;
    }
    return 60 * (24 * days + hours) + minutes;
}
function createDate(value, options) {
    let dayjs_date = undefined;
    if (!(options === null || options === void 0 ? void 0 : options.format)) {
        if (value) {
            dayjs_date = dayjs(value);
        }
    }
    else if ((options === null || options === void 0 ? void 0 : options.format) === 'timestamp') {
        dayjs_date = dayjs(Number(value));
    }
    else if ((options === null || options === void 0 ? void 0 : options.format) === 'unix') {
        dayjs_date = dayjs(Number(value) * 1000);
    }
    else if (options.format === 'server-time') {
        return new Date((Number(value) + (new Date().getTimezoneOffset() * 60)) * 1000);
    }
    if (!dayjs_date) {
        dayjs_date = dayjs(value, options === null || options === void 0 ? void 0 : options.format);
    }
    if (options === null || options === void 0 ? void 0 : options.timezone) {
        const date = dayjs_date.toDate();
        const unix = date.getUnix() + (date.getTimezoneOffset() * 60) - (getTimezoneOffset(options.timezone, date.getUnix()) * 60);
        return new Date(unix * 1000);
    }
    return dayjs_date.toDate();
}
Date.create = function (value, options) {
    if (!options || typeof options === 'string') {
        options = {
            format: options
        };
    }
    return createDate(value, options);
};
Date.setGlobalLocale = function (locale) {
    Date.locale = locale === null || locale === void 0 ? void 0 : locale.replace('_', '-');
    is_24_hours = locales_24_hour.includes(locale || '');
};
Date.getMonthByName = function (month) {
    const shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const shortIndex = shortMonths.indexOf(month);
    if (shortIndex > -1) {
        return shortIndex;
    }
    const longMonths = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    return longMonths.indexOf(month);
};
Date.getDaysInMonth = function (month, year) {
    const date = new Date();
    year && date.setFullYear(year);
    date.setMonth((month || 0) + 1);
    date.setDate(0);
    return date.getDate();
};
Date.prototype.getUnix = function () {
    return Math.floor(this.getTime() / 1000);
};
Date.prototype.toDefaultString = function () {
    return dayjs(this).format('YYYY-MM-DD HH:mm');
};
Date.prototype.clone = function () {
    return new Date(this.getTime());
};
Date.prototype.getDaysInMonth = function () {
    const copiedDate = new Date(this.getTime());
    copiedDate.addMonths(1);
    copiedDate.setDate(0);
    return copiedDate.getDate();
};
Date.prototype.getMonthName = function (type) {
    return new Intl.DateTimeFormat(undefined, { month: type || 'long' }).format(this);
};
Date.prototype.getDayName = function (type) {
    return new Intl.DateTimeFormat(undefined, { weekday: type || 'long' }).format(this);
};
Date.prototype.getFormatedDate = function (options) {
    const intlOptions = Object.assign({ day: 'numeric', month: 'short', year: 'numeric' }, options);
    if (!Date.locale) {
        return new Intl.DateTimeFormat(undefined, intlOptions).format(this);
    }
    try {
        return new Intl.DateTimeFormat(Date.locale || undefined, intlOptions).format(this);
    }
    catch (error) {
        console.error(error);
        return new Intl.DateTimeFormat(undefined, intlOptions).format(this);
    }
};
Date.prototype.getFormatedTime = function (options) {
    const intlOptions = Object.assign({ hour: 'numeric', minute: 'numeric' }, options);
    if (!Date.locale) {
        return new Intl.DateTimeFormat(undefined, intlOptions).format(this);
    }
    if (!intlOptions.hourCycle && Date.locale) {
        intlOptions.hourCycle = is_24_hours
            ? 'h24'
            : 'h12';
    }
    try {
        return new Intl.DateTimeFormat(Date.locale || undefined, intlOptions).format(this);
    }
    catch (error) {
        console.error(error);
        return new Intl.DateTimeFormat(undefined, intlOptions).format(this);
    }
};
Date.prototype.getFormatedValue = function (options) {
    const intlOptions = Object.assign({ day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric' }, options);
    if (!Date.locale) {
        return new Intl.DateTimeFormat(undefined, intlOptions).format(this);
    }
    try {
        return new Intl.DateTimeFormat(Date.locale || undefined, intlOptions).format(this);
    }
    catch (error) {
        console.error(error);
        return new Intl.DateTimeFormat(undefined, intlOptions).format(this);
    }
};
Date.prototype.format = function (format) {
    return dayjs(this).format(format);
};
Date.prototype.addYears = function (years) {
    this.setFullYear(this.getFullYear() + years);
    return this;
};
Date.prototype.addMonths = function (months) {
    this.setMonth(this.getMonth() + months);
    return this;
};
Date.prototype.addDays = function (days) {
    this.setDate(this.getDate() + days);
    return this;
};
Date.prototype.addHours = function (hours) {
    this.setHours(this.getHours() + hours);
    return this;
};
Date.prototype.addMinutes = function (minutes) {
    this.setMinutes(this.getMinutes() + minutes);
    return this;
};
Date.prototype.removeYears = function (years) {
    this.setFullYear(this.getFullYear() - years);
    return this;
};
Date.prototype.removeMonths = function (months) {
    this.setMonth(this.getMonth() - months);
    return this;
};
Date.prototype.removeDays = function (days) {
    this.setDate(this.getDate() - days);
    return this;
};
Date.prototype.removeHours = function (hours) {
    this.setHours(this.getHours() - hours);
    return this;
};
Date.prototype.removeMinutes = function (minutes) {
    this.setMinutes(this.getMinutes() - minutes);
    return this;
};
Date.prototype.isValid = function () {
    return dayjs(this).isValid();
};
